export default (state = {}, action) => {
  switch (action.type) {
    case 'LOGIN': {
      return {
        ...state,
        user: action.userdata,
        userHasAuthenticated: true,
      };
    }
    case 'LOGOUT': {
      return {
        ...state,
        user: null,
        userHasAuthenticated: false,
      };
    }
    case 'SET_USER': {
      return {
        ...state,
        user: action.userdata,
        userHasAuthenticated: true,
      };
    }
    case 'SET_DELETED_USER': {
      return {
        ...state,
        deletedUser: action.userdata,
      };
    }
    case 'SET_USER_FILTERS': {
      return {
        ...state,
        userFilters: action.data,
      };
    }
    case 'SET_USER_FILTER_FLAG': {
      return {
        ...state,
        activeFilter: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
